'use client';

import React, { forwardRef, useState, useEffect } from 'react';
import { clsx } from 'clsx';
import { MediaUploading } from 'app/libs/useMediaManager';
import { type BasicShopUIPropTypes, type BuyerLayoutProps } from 'shop-ui/types';
import { CarouselViewport } from './CarouselViewport';
import { useCarousel } from './useCarousel';
import './Carousel.scss';

interface CarouselProps extends BasicShopUIPropTypes, BuyerLayoutProps {
    // 自行加入其他 props
    content: string;
    isUploading: boolean;
}

export const Carousel = forwardRef<HTMLDivElement, CarouselProps>((props, ref) => {
    const { isEditingMode, style, isBuyer, isUploading } = props;

    const { state, action } = useCarousel(props, ref as React.RefObject<HTMLDivElement>);

    const { selectedIndex, slides, emblaMainRef } = state;

    const { emblaMainApi, onDotButtonClick } = action;

    const [hydrated, setHydrated] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setHydrated(true);
        }, 500);

        return () => clearTimeout(timer);
    }, []);

    if (!hydrated) {
        return (
            <div ref={ref} className="carousel skeleton skeleton--full">
                <div className="carousel__viewport"></div>
            </div>
        );
    }

    if (isUploading) {
        return (
            <div
                ref={ref}
                style={style}
                className="shop-ui-media shop-ui-media--uploading"
            >
                <MediaUploading />
            </div>
        );
    }

    return (
        <div ref={ref} className={clsx('carousel', isEditingMode && 'is-editing')}>
            <CarouselViewport
                isBuyer={isBuyer}
                viewportRef={emblaMainRef}
                api={{ main: emblaMainApi }}
                selectedIndex={selectedIndex}
                slides={slides}
                isEditingMode={isEditingMode}
                onDotButtonClick={onDotButtonClick}
            />
        </div>
    );
});

Carousel.displayName = 'Carousel';
